import { useState, useEffect, useCallback } from "react";
import api from "services/api";
import { filterConsommations } from "components/dashboard/dashboardFilters";

const useDashboardData = ({
  searchQuery,
  startDate,
  endDate,
  paymentStatusFilter,
}) => {
  const [consommations, setConsommations] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [formattedData, setFormattedData] = useState([]);
  const [noResultsMessage, setNoResultsMessage] = useState("");

  const calculateTotalPaidAmount = useCallback((data) => {
    const total = data.reduce(
      (sum, record) => sum + (record.paidAmount || 0),
      0
    );

    setTotalPaidAmount(total.toFixed(2));
  }, []);

  const applyFilters = useCallback(
    (data) => {
      const filteredData = filterConsommations({
        data,
        searchQuery,
        startDate,
        endDate,
        paymentStatusFilter,
      });

      setConsommations(filteredData);
      calculateTotalPaidAmount(filteredData);

      if (filteredData.length === 0) {
        setNoResultsMessage("Aucune donnée trouvée avec les filtres appliqués.");
      } else {
        setNoResultsMessage("");
      }
    },
    [
      calculateTotalPaidAmount,
      searchQuery,
      startDate,
      endDate,
      paymentStatusFilter,
    ]
  );

  useEffect(() => {
    const fetchConsommations = async () => {
      try {
        const response = await api.get("/api/consommations");

        const data = response.data.map((item) => ({
          ...item,
          paidAmount: Number(item.paidAmount) || 0,
        }));

        data.sort((a, b) => b.id - a.id);

        setFormattedData(data);
        applyFilters(data);
      } catch (error) {
        console.error("Failed to fetch consommations:", error);
      }
    };

    fetchConsommations();
  }, [applyFilters]);

  return {
    consommations,
    totalPaidAmount,
    formattedData,
    noResultsMessage,
  };
};

export default useDashboardData;